import React from 'react';

/**
 * Drop-in replacement for <img>.
 * - Shows a fixed-size neutral placeholder when src is empty (no layout shift, no stock-image flash).
 * - Defaults to loading="lazy" + decoding="async" for below-fold images.
 * - Pass loading="eager" for above-the-fold / hero images.
 */
const CmsImage = ({ src, alt, className, style, loading = 'lazy' }) => {
  if (!src) {
    return (
      <div
        className={className}
        style={{ backgroundColor: '#E5E7EB', ...style }}
        aria-hidden="true"
        role="presentation"
      />
    );
  }
  return (
    <img
      src={src}
      alt={alt || ''}
      className={className}
      style={style}
      loading={loading}
      decoding="async"
    />
  );
};

export default CmsImage;
